<wl-faq
  trackImpression="contentblock-impression"
  [trackImpressionInfo]="rendering"
  [faqAccordionViewModel]="faqAccordionViewModel"
></wl-faq>
